import { translate } from 'hooks/useTranslate';
import { axiosV2 } from 'interceptors/axios';
import { downloadBlob } from 'utils/downloadBlob';

type DownloadDividendFiscalDocumentProps = {
  operationId: string;
};

export const downloadDividendFiscalDocument = async ({
  operationId,
}: DownloadDividendFiscalDocumentProps) => {
  const { data } = await axiosV2.get<Blob>(
    '/operations/dividend-fiscal-document',
    { params: { operationId }, responseType: 'blob' }
  );

  downloadBlob(data, `${translate('Dividend')}.xlsx`);
};
